import { Link, useLocation, useNavigate } from "react-router-dom";
import { Instagram, Facebook, Linkedin } from "lucide-react";
import { BRAND, SOCIAL } from "@/config/site";
import { scrollToHash } from "@/lib/prefill";
import { openConsentBanner } from "@/lib/consent";

const socials = [
  { key: "instagram", url: SOCIAL.instagram, Icon: Instagram, label: "Instagram" },
  { key: "facebook", url: SOCIAL.facebook, Icon: Facebook, label: "Facebook" },
  { key: "linkedin", url: SOCIAL.linkedin, Icon: Linkedin, label: "LinkedIn" },
].filter((s) => s.url);

export const Footer = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isHome = pathname === "/";
  return (
  <footer className="bg-forest-deep text-ivory" data-testid="site-footer">
    <div className="container-ph py-14 grid gap-10 md:grid-cols-3 items-start">
      <div>
        <div className="flex flex-col items-start">
          <span className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-ivory p-2" data-testid="footer-logo-tile">
            <img src={BRAND.monogram} alt="Progetto HOSPITALITY" className="h-full w-auto object-contain" />
          </span>
          <span className="mt-3 font-serif text-base font-semibold tracking-[0.2em] uppercase leading-none" data-testid="footer-brand">{BRAND.name}</span>
        </div>
        <p className="mt-3 text-sm text-ivory/70">{BRAND.subtitle}</p>
      </div>
      <nav className="flex flex-col gap-2.5 text-sm" aria-label="Link footer">
        <Link to="/privacy" className="hover:text-bronze transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link>
        <Link to="/cookie" className="hover:text-bronze transition-colors" data-testid="footer-cookie-link">Cookie Policy</Link>
        <a href="/#contatti" onClick={(e) => { e.preventDefault(); isHome ? scrollToHash("#contatti") : navigate("/#contatti"); }} className="hover:text-bronze transition-colors" data-testid="footer-contatti-link">Contatti</a>
        <button type="button" onClick={openConsentBanner} className="text-left hover:text-bronze transition-colors" data-testid="footer-cookie-preferences-button">Preferenze cookie</button>
      </nav>
      <div>
        <p className="eyebrow mb-3">Social</p>
        {socials.length > 0 ? (
          <div className="flex gap-4" data-testid="footer-social-links">
            {socials.map(({ key, url, Icon, label }) => (
              <a key={key} href={url} target="_blank" rel="noopener noreferrer" aria-label={label} className="hover:text-bronze transition-colors" data-testid={`footer-social-${key}`}><Icon size={20} /></a>
            ))}
          </div>
        ) : (
          <p className="text-sm text-ivory/50" data-testid="footer-social-placeholder">Canali social in arrivo.</p>
        )}
      </div>
    </div>
    <div className="border-t border-ivory/10">
      <div className="container-ph py-5 text-xs text-ivory/50" data-testid="footer-copyright">© {new Date().getFullYear()} {BRAND.name}. Tutti i diritti riservati.</div>
    </div>
  </footer>
  );
};
